import {
	GridColumnProps,
	GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { t } from "i18next";
import { CellPopoverWithText } from "ui/grid/DescriptionCell";

export function agreementUsersGridColumns(): GridColumnProps[] {
	return [
		{
			field: "userFirstName",
			title: t("FirstName"),
			width: 190,
		},
		{
			field: "userLastName",
			title: t("LastName"),
			filter: "text",
			width: 190,
		},
		{
			field: "userEmail",
			title: t("Email"),
			width: 200,

			cells: {
				data: (props) => {
					return (
						<CellPopoverWithText {...props} text={props.dataItem.userEmail} />
					);
				},
			},
		},
		{ field: "userPhoneDisplay", title: t("PhoneNumber"), width: 170 },
		{
			field: "buyerName",
			title: `${t("Buyer")}`,
			cells: {
				data: (props) => {
					return (
						<CellPopoverWithText
							{...props}
							text={props.dataItem.buyerDisplay}
						/>
					);
				},
			},
		},
		{
			field: "vesselName",
			title: `${t("Vessel")}`,
			cells: {
				data: (props) => {
					return (
						<CellPopoverWithText
							{...props}
							text={props.dataItem.vesselDisplay}
						/>
					);
				},
			},
		},
		{
			field: "terminalName",
			title: `${t("Terminal")}`,
			cells: {
				data: (props) => {
					return (
						<CellPopoverWithText
							{...props}
							text={props.dataItem.terminalName}
						/>
					);
				},
			},
		},
	];
}
